import { render, staticRenderFns } from "./person-demographics.vue?vue&type=template&id=81dbb3ce&scoped=true"
import script from "./person-demographics.vue?vue&type=script&lang=js"
export * from "./person-demographics.vue?vue&type=script&lang=js"
import style0 from "./person-demographics.vue?vue&type=style&index=0&id=81dbb3ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81dbb3ce",
  null
  
)

export default component.exports